import React, { useState, useEffect, useRef } from "react";
import { CButton, CFormLabel } from "@coreui/react";
import { getPaymentReceiptUrl } from "src/views/CommonFunctions/PaymentReceiptUrl";

const ALLOWED_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
  "application/pdf",
];
const MAX_SIZE = 10 * 1024 * 1024;

function PaymentReceiptUpload({
  existingFile,
  onFileChange,
  readOnly,
  imageSize = 400,
  from = "",
  hidePreview = false,
}) {
  const [preview, setPreview] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (existingFile) {
      getPaymentReceiptUrl(existingFile).then((url) => {
        const ext = existingFile.split(".").pop().toLowerCase();
        if (["jpg", "jpeg", "png", "webp"].includes(ext)) {
          setPreview(url);
          setFileType("image");
        } else if (ext === "pdf") {
          setPreview(url);
          setFileType("pdf");
        }
      });
    } else {
      setPreview(null);
      setFileType(null);
      setSelectedFile(null);
    }
  }, [existingFile]);

  const validateFile = (file) => {
    if (!ALLOWED_TYPES.includes(file.type)) {
      setError("Only JPG, JPEG, PNG, WEBP or PDF files are allowed");
      return false;
    }
    if (file.size > MAX_SIZE) {
      setError("File size must be less than 10 MB");
      return false;
    }
    return true;
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setError("");
    if (!validateFile(file)) {
      e.target.value = "";
      return;
    }
    setSelectedFile(file);
    if (file.type === "application/pdf") {
      setPreview(URL.createObjectURL(file));
      setFileType("pdf");
    } else {
      setPreview(URL.createObjectURL(file));
      setFileType("image");
    }
    onFileChange(file);
  };

  const handleRemove = () => {
    setPreview(null);
    setFileType(null);
    setSelectedFile(null);
    setError("");
    if (inputRef.current) inputRef.current.value = "";
    onFileChange({ remove: true });
  };

  const handleReplace = () => {
    inputRef.current.click();
  };

  const previewContent = () => {
    if (!preview) return null;
    if (fileType === "pdf") {
      return (
        <div style={{ marginTop: 8 }}>
          <iframe
            src={preview}
            title="Receipt Preview"
            style={{
              width: "100%",
              // height: 500,
              size: imageSize,
              border: "1px solid #ddd",
              borderRadius: 4,
            }}
          />
          <div style={{ marginTop: 4, fontSize: 12, color: "#666" }}>
            PDF Preview
          </div>
        </div>
      );
    }
    return (
      <div style={{ marginTop: 8 }}>
        <img
          src={preview}
          alt="Receipt Preview"
          style={{
            maxWidth: "100%",
            maxHeight: 500,
            objectFit: "contain",
            border: "1px solid #ddd",
            borderRadius: 4,
          }}
        />
      </div>
    );
  };

  return (
    <div>
      <CFormLabel style={{ color: "#003366", fontWeight: "bold" }}>
        Upload <b>{from === "lead" && "only Single"}</b> Payment Screenshot /
        Receipt{" "}
      </CFormLabel>
      {from === "lead" && (
        <div>
          <small style={{ color: "red" }}>
            (If multiple screenshots, send it by email)
          </small>
        </div>
      )}
      <div
        style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 4 }}
      >
        <input
          ref={inputRef}
          type="file"
          accept=".jpg,.jpeg,.png,.webp,.pdf"
          onChange={handleFileSelect}
          style={{ display: "none" }}
          disabled={readOnly}
        />
        {!preview && !readOnly && (
          <CButton
            color="primary"
            size="sm"
            onClick={() => inputRef.current.click()}
          >
            {existingFile ? "Replace File" : "Upload here / Choose File"}
          </CButton>
        )}
        {preview && !readOnly && (
          <>
            <CButton color="warning" size="sm" onClick={handleReplace}>
              Replace
            </CButton>
            <CButton color="danger" size="sm" onClick={handleRemove}>
              Remove
            </CButton>
          </>
        )}
      </div>
      {error && (
        <div style={{ color: "red", fontSize: 11, marginTop: 2 }}>{error}</div>
      )}
      <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>
        Accepted: JPG, JPEG, PNG, WEBP, PDF (Max 10 MB)
      </div>
      {!hidePreview && previewContent()}
    </div>
  );
}

export default PaymentReceiptUpload;
